import { Pipe, PipeTransform } from '@angular/core';
import {Project} from '../../model/project';
import {Terminal} from '../../model/terminal';
import {Questionnaire} from '../../model/questionnaire';


@Pipe({
  name: 'tag',
  pure: false // impure pipe, update value when we change language
})

export class TagPipe implements PipeTransform {

  constructor() { }

  transform(value:(Project|Terminal|Questionnaire)[],term: string,key:string): any[] {

    if(value == null) {
      return;
    }

    return value.filter(item => {
      return Object.keys(item).some(() => {
        return String(item[key]).toLowerCase().includes(term.toLowerCase());
      });
    });
  }
}
